import { useMutation } from "react-query";
import { submitFormData } from "../fetchers/form-submission"

export const useSubmitDesignForm = () => {
  const {
    isLoading,
    mutate: submitDesignForm,
  } = useMutation(["submit-design-form"], submitFormData);

  return {
    submitDesignForm,
    isLoading,
  };
};
